import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { NotificationsController } from './notifications.controller';
import { Notifications } from './notifications.entity';
import { NotificationsService } from './notifications.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([Notifications]),
  ],
  controllers: [NotificationsController],
  providers: [NotificationsService,ApplicationExceptionHandler]
})
export class NotificationsModule {}
